
export const environment = {
  production: true,
  name: "Production",

  auth0: {
    domain: 'transnetyx-prod.us.auth0.com',
    clientId: 'NHJO4hnmDUL3CaYhP93c6V1JPFFQmMWK',
    audience: 'Ops_Instrudex_API',
    scope: '',
    redirectUri: `https://instrudex.transnetyx.com`
  },

  apiUrl: "https://api.transnetyx.com/instrudex/"
};
